if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLDivElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.tabPanels = this.querySelector('.tabs__panels') || this.querySelector('.section__content');
        this.tabBtns = this.querySelectorAll('.tabs__btn, .tabs-btn');
        this.panelSelector = this.querySelector('.tabs__panels') ? '.tabs__panel' : '.featured-collection__content';
        this.currentIndex = 0;
        this.init();
      }

      init() {
        this.tabBtns.forEach((btn) => {
          btn.addEventListener('click', this.onClick.bind(this));
        });

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            const index = Number(e.target.dataset.index);
            this.setActiveTab(index);
          });
        }
      }

      onClick(e) {
        e.preventDefault();
        const button = e.target.closest('button');
        if (!button) return;
        this.setActiveTab(Number(button.dataset.index));
      }

      setActiveTab(index) {
        if (this.currentIndex === index) return;

        const currentItem = this.tabBtns[this.currentIndex];
        const newBtn = this.tabBtns[index];

        currentItem && currentItem.classList.remove('active');
        newBtn && newBtn.classList.add('active');

        this.tabPanels.querySelectorAll(this.panelSelector).forEach((panel) => {
          panel.hidden = true;
        });

        let newTab = this.tabPanels.querySelector(`${this.panelSelector}[data-index="${index}"]`);

        if (!newTab) {
          const template = this.tabPanels.querySelector(`template[data-index="${index}"]`);
          if (template) {
            newTab = template.content.cloneNode(true).firstElementChild;
            this.tabPanels.appendChild(newTab);
          }
        }

        if (!newTab) return;

        const translateY = FoxTheme.config.motionReduced ? 0 : 2.5;

        FoxTheme.Motion.animate(newTab, { transform: `translateY(${translateY}rem)`, opacity: 0.01 }, { duration: 0 });

        newTab.hidden = false;
        this.fixBlurryImagesOnSafari(newTab);

        setTimeout(() => {
          FoxTheme.Motion.animate(
            newTab,
            { transform: 'translateY(0)', opacity: 1 },
            { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
          );
        }, 50);

        this.currentIndex = index;

        this.dispatchEvent(
          new CustomEvent('tabChange', {
            bubbles: true,
            detail: { selectedIndex: index, selectedTab: newTab },
          })
        );
      }

      fixBlurryImagesOnSafari(tab) {
        const isOldSafari =
          /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && navigator.userAgent.includes('Version/15.');

        if (!isOldSafari || tab.classList.contains('images-loaded')) return;

        tab.classList.add('images-loaded');
        tab.querySelectorAll('img[srcset]').forEach((img) => {
          const src = img.currentSrc || img.src;
          img.srcset = img.srcset;
          img.src = '';
          img.src = src;
        });
      }
    },
    { extends: 'div' }
  );
}
